<mat-form-field class="tw-w-full" appearance="outline">
    <input matInput [formControl]="control" disabled>
  </mat-form-field>
